import Router from "@services/router";
import SalonAcceptancesPage from "@jury/components/pages/SalonAcceptances";
import SalonNominationsPage from "@jury/components/pages/SalonNominations";
import CurrentPage from "@jury/components/pages/Current";

export default [
    Router.page({ name: ["jury", "jury:current"], path: "/app/jury", component: CurrentPage }),
    Router.page({ name: "jury:salon", path: "/app/jury/salons/:id", component: SalonNominationsPage }),
    Router.page({ name: "jury:salon:acceptances", path: "/app/jury/salons/:id/acceptances", component: SalonAcceptancesPage }),
]